<template>
  <AppModal ref="modal" :stacked="true" @close="$emit('close')" @clickaway="close">
    <template slot="modal-header">
      <h3 class="font-weight-medium">
        Set Percent Ownership
      </h3>
    </template>
    <template slot="modal-body">
      <div v-if="valueWithChanges.length">
        <div class="d-flex mb-2">
          <div class="flex-1">Owner</div>
          <div class="flex-1">Percent Ownership (%)</div>
          <div class="flex-1 ml-4">Primary</div>
          <div class="flex-1">Allowed To Offer</div>

        </div>
        <div v-for="(deptOwnership, index) in valueWithChanges" :key="index" class="d-flex">
          <div class="flex-1">
            {{ departmentDisplayName(deptOwnership.deptId) }}
          </div>
          <div class="flex-1">
            <FormNumber
              v-if="deptOwnership.deptId"
              class="mb-2"
              :value="deptOwnership.percentOwnership"
              @input="setDeptOwnership(index, {...deptOwnership, percentOwnership: $event})"
            />
          </div>
          <template v-if="deptOwnership.deptId">
            <div class="flex-1 ml-4">
              <FormYesNo
                class="mb-2"
                :value="deptOwnership.primaryDepartment"
                @input="setPrimaryDept(index, {...deptOwnership, primaryDepartment: $event})"
              />
            </div>
            <div class="flex-1">
              <FormYesNo
                class="mb-2"
                :value="deptOwnership.allowedToOffer"
                @input="setDeptOwnership(index, {...deptOwnership, allowedToOffer: $event})"
              />
            </div>
          </template>
        </div>
      </div>
      <div v-else class="text-center text-muted my-4">
        No departments added.
      </div>
    </template>
    <template slot="modal-footer">
      <AppButton @click="close">Close</AppButton>
    </template>
  </AppModal>
</template>

<script>
import FormNumber from '../FormNumber'
import FormYesNo from '../FormYesNo'

import { mapGetters } from 'vuex'

export default {
  components: { FormNumber, FormYesNo },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return { valueWithChanges: [] }
  },
  computed: {
    ...mapGetters('departments', [ 'departmentDisplayName' ]),
  },
  created () {
    this.valueWithChanges = [ ...this.value ]
  },
  methods: {
    close () {
      if (this.$refs.modal) {
        this.$refs.modal.close()
      }
      this.$emit('close')
    },
    update () {
      this.$emit('update', this.valueWithChanges)
    },
    setDeptOwnership (index, value) {
      this.$set(this.valueWithChanges, index, value)
      this.update()
    },
    setPrimaryDept (index, value) {
      // First set all primary department values to "false",
      // as only 1 primary department is allowed
      this.valueWithChanges = this.valueWithChanges.map(el => ({
        ...el,
        primaryDepartment: false,
      }))
      this.$set(this.valueWithChanges, index, value)
      this.update()
    },
  },
}
</script>

<style scoped>
.modal-backdrop >>> .modal-body {
  overflow: unset;
  max-height: 100%;
}
</style>
